"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Coverage() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const regions = [{
    city: "Śląsk",
    code: "SLK",
    cx: 38,
    cy: 62
  }, {
    city: "Małopolska",
    code: "MLP",
    cx: 52,
    cy: 65
  }, {
    city: "Wielkopolska",
    code: "WLK",
    cx: 28,
    cy: 30
  }, {
    city: "Dolnyśląsk",
    code: "DW",
    cx: 22,
    cy: 55
  }, {
    city: "Łudzkie",
    code: "ŁU",
    cx: 48,
    cy: 38
  }, {
    city: "Opolskie",
    code: "OPL",
    cx: 30,
    cy: 58
  }, {
    city: "Świętokrzyskie",
    code: "SWK",
    cx: 58,
    cy: 55
  }, {
    city: "Czechy",
    code: "CZE",
    cx: 30,
    cy: 72
  }];
  return <section data-section-id="3577" id="gdzie-działamy" className="bg-background text-foreground py-32 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={contentRef} className={`lg:col-span-5 order-2 lg:order-1 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground mb-8">
              Obszar — Działalność
            </div>

            <h2 className="font-default text-5xl md:text-6xl leading-[1.05] font-bold mb-8">
              Zasięg
              <br />
              <span className="italic text-blue-600 !font-medium">HydroRoof</span>
            </h2>

            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground mb-12 max-w-md">
              Naszym głównym obszarem działań jest południowa Polska oraz pogranicze czeskie. Dzięki lokalnej obecności zapewniamy szybki czas reakcji i profesjonalną obsługę inwestycji w całym regionie.
            </p>

            <div className="mt-12">
              {regions.map((region, i) => <div data-index={i} key={region.code}>
                  <div className="flex items-baseline justify-between py-5 group cursor-default">
                    <span className="font-default text-2xl md:text-3xl font-semibold text-foreground transition-colors duration-300 group-hover:text-blue-600">
                      {region.city}
                    </span>
                    <span className="font-default text-xs tracking-[0.3em] text-muted-foreground">
                      {region.code}
                    </span>
                  </div>
                  {i < regions.length - 1 && <Separator className="bg-border/60" />}
                </div>)}
            </div>
          </div>

          {}
          <div ref={mapRef} className={`lg:col-span-7 order-1 lg:order-2 transition-all duration-1000 ease-out delay-200 ${mapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative overflow-hidden bg-muted aspect-[4/3] md:aspect-[5/4] rounded-lg shadow-lg">
              {}
              <div className="absolute inset-0 opacity-[0.08] mix-blend-multiply pointer-events-none" style={{
              backgroundImage: "radial-gradient(circle at 20% 30%, hsl(222 24% 8%) 1px, transparent 1px), radial-gradient(circle at 70% 60%, hsl(222 24% 8%) 1px, transparent 1px)",
              backgroundSize: "24px 24px, 32px 32px"
            }} />

              {}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "radial-gradient(ellipse at center, transparent 50%, hsl(200 95% 45% / 0.12) 100%)"
            }} />

              {}
              <svg viewBox="0 0 100 80" className="absolute inset-0 w-full h-full p-6 md:p-10" preserveAspectRatio="xMidYMid meet">
                <g fill="none" stroke="hsl(210 10% 30%)" strokeWidth="0.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.7">
                  {}
                  <path d="M45,5 L60,8 L75,5 L85,15 L95,30 L90,45 L80,60 L65,65 L50,62 L35,65 L20,60 L10,45 L5,30 L15,15 L30,8 Z" />
                  
                  {}
                  <path d="M35,65 Q45,55 50,62" /> {}
                  <path d="M50,62 Q55,50 65,65" /> {}
                  <path d="M30,40 L50,45 L70,40" /> {}
                  <path d="M50,45 L50,62" /> {}
                  
                  {}
                  <path d="M30,68 L45,75 L60,72" strokeDasharray="0.5 1" opacity="0.5" />

                  {}
                  <line x1="0" y1="40" x2="100" y2="40" strokeDasharray="0.3 1.5" opacity="0.3" />
                  <line x1="50" y1="0" x2="50" y2="80" strokeDasharray="0.3 1.5" opacity="0.3" />
                </g>

                {}
                {regions.map((region, i) => <g key={region.code} data-index={i} className="group cursor-pointer">
                    {}
                    <circle cx={region.cx} cy={region.cy} r="1.5" fill="hsl(200 95% 45%)" opacity="0.3" className="origin-center transition-all duration-500 group-hover:opacity-60" style={{
                  animation: `hydro-pulse 2.${i}s ease-in-out infinite`,
                  transformOrigin: `${region.cx}px ${region.cy}px`
                }} />
                    {}
                    <circle cx={region.cx} cy={region.cy} r="0.8" fill="hsl(200 95% 45%)" className="transition-all duration-300 group-hover:r-1.2" />
                    {}
                    <line x1={region.cx + 1.5} y1={region.cy} x2={region.cx + 6} y2={region.cy - 4} stroke="hsl(210 10% 30%)" strokeWidth="0.15" className="transition-all duration-300 group-hover:stroke-blue-600" />
                    {}
                    <text x={region.cx + 7} y={region.cy - 4} fontSize="2.5" fill="currentColor" fontWeight="600" fontFamily="sans-serif" className="transition-all duration-300 group-hover:fill-blue-600">
                      {region.city}
                    </text>
                  </g>)}
              </svg>

              {}
              <div className="absolute top-6 right-6 md:top-8 md:right-8 font-default text-[10px] tracking-[0.3em] text-muted-foreground/70">
                HR · 50.26° N, 19.02° E
              </div>
              <div className="absolute bottom-6 left-6 md:bottom-8 md:right-8 font-default italic text-xs text-muted-foreground/70">
                fig. i — główny obszar operacyjny
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes hydro-pulse {
          0%, 100% { transform: scale(1); opacity: 0.3; }
          50% { transform: scale(2.5); opacity: 0.05; }
        }
      `}</style>
    </section>;
}